import "jquery";
import Rails from "@rails/ujs";
Rails.start();

window.InfiniteScroll = require("infinite-scroll");
window.qs = require("qs");
window.toastr = require("toastr");
window.toastr.options["positionClass"] = "toast-top-center";

import "bootstrap/js/dist/modal";
window.lightbox = require("lightbox2");
window.I18n = require("./i18n/i18n").default;

window.Dropzone = require("dropzone");
Dropzone.autoDiscover = false;

window.Sortable = require("sortablejs/modular/sortable.core.esm.js").default;
window.Diff = require("diff");

import "jquery-bar-rating"; //STAR rating plugin

import "izimodal";
import "izimodal/css/iziModal.css";

import { dom } from "./fortawesome/fontawesome-svg-core";
window.fontAwesomeDom = dom;

require("leaflet");
require("leaflet-contextmenu");

//STYLESHEETS

//import "izimodal/css/iziModal.css";
import "lightbox2/src/css/lightbox.css";
import "toastr/toastr.scss";
import "dropzone/dist/dropzone.css";
import "dropzone/dist/basic.css";
import "leaflet/dist/leaflet.css";
import "leaflet-contextmenu/dist/leaflet.contextmenu.css";
import "./sass-styles/bootstrap.scss";

import "./fontAwesomeCustom";

function importAll(r) {
  //https://webpack.js.org/guides/dependency-management/#require-with-expression
  r.keys().forEach(r);
}

importAll(require.context("./frontend", true, /\.(js|js.erb)$/));
importAll(require.context("../assets/stylesheets/frontend", true));
